var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useModal } from '../../../hooks/useModal';
import { useReviews } from '../../../hooks/useReviews';
import { calculateAverageRating } from '../../../utils/review';
import { ErrorMessage } from '../../atoms/ErrorMessage';
import { LoadingSpinner } from '../../atoms/LoadingSpinner';
import { Modal } from '../../atoms/Modal';
import { Pagination } from '../../molecules/Pagination';
import { ReviewHeader } from '../../molecules/ReviewHeader';
import { ReviewForm } from '../../organisms/ReviewForm';
import { ReviewList } from '../../organisms/ReviewList';
var ReviewWidget = function (_a) {
    var siteId = _a.siteId, _b = _a.initialSort, initialSort = _b === void 0 ? 'date' : _b;
    var sortBy = useState(initialSort)[0];
    var filterBy = useState('all')[0];
    var _c = useState(0), refreshTrigger = _c[0], setRefreshTrigger = _c[1];
    var _d = useReviews({ siteId: siteId, sortBy: sortBy, filterBy: filterBy, refreshTrigger: refreshTrigger }), _e = _d.reviews, reviews = _e === void 0 ? [] : _e, loading = _d.loading, error = _d.error, addReview = _d.addReview;
    var _f = useModal(), isOpen = _f.isOpen, openModal = _f.openModal, closeModal = _f.closeModal;
    var _g = useState(1), currentPage = _g[0], setCurrentPage = _g[1];
    var itemsPerPage = 4; // Number of reviews per pages
    // Calculate total pages
    var totalPages = Math.ceil(((reviews === null || reviews === void 0 ? void 0 : reviews.length) || 0) / itemsPerPage);
    // Get current page reviews
    var getCurrentPageReviews = function () {
        var startIndex = (currentPage - 1) * itemsPerPage;
        var endIndex = startIndex + itemsPerPage;
        return (reviews === null || reviews === void 0 ? void 0 : reviews.slice(startIndex, endIndex)) || [];
    };
    // Handle page change
    var handlePageChange = function (page) {
        setCurrentPage(page);
    };
    var handleReply = function (reviewId) {
        // Implement reply logic
    };
    var handleLike = function (reviewId) {
        // Implement like logic
    };
    var handleReport = function (reviewId) {
        // Implement report logic
    };
    var handleReviewSubmitted = function () {
        // Increment the refresh trigger to cause a refetch
        setRefreshTrigger(function (prev) { return prev + 1; });
    };
    if (loading)
        return _jsx(LoadingSpinner, {});
    if (error)
        return _jsx(ErrorMessage, { message: error.message });
    return (_jsxs("div", __assign({ id: "review-widget-root", className: "flex flex-col max-w-xl mx-auto bg-white p-6 rounded-xl shadow-lg gap-[10px]" }, { children: [_jsx(ReviewHeader, { totalReviews: (reviews === null || reviews === void 0 ? void 0 : reviews.length) || 0, averageRating: calculateAverageRating(reviews || []), onWriteReview: openModal }), _jsx(ReviewList, { reviews: getCurrentPageReviews(), onReply: handleReply, onLike: handleLike, onReport: handleReport }), _jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: handlePageChange }), _jsx(Modal, __assign({ isOpen: isOpen, onClose: closeModal, onSubmitSuccess: handleReviewSubmitted, siteId: siteId }, { children: _jsx(ReviewForm, { onSubmit: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, addReview(data)];
                                case 1:
                                    _a.sent();
                                    closeModal();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }) }))] })));
};
export default ReviewWidget;
